import styled from "styled-components";
export const HeadingWrap = styled.div`
    margin-bottom: 40px;
    font-size: 16px;
    line-height: 20px;
    width: 100%;
    max-width: 410px;
    color: var(--text-color);
    @media (min-width: 992px) {
        font-size: 20px;
        line-height: 24px;
    }
    .logo {
        cursor: pointer;
        max-width: 200px;
        margin-bottom: 30px;
        @media (min-width: 1200px) {
            min-width: 25px;
        }
        img {
            width: 100%;
            height: auto;
        }
    }
    .h1 {
        text-align: left;
        color: var(--text-color);
        font-size: 26px;
        line-height: 30px;
        font-weight: 400;
        @media (min-width: 1200px) {
            font-size: 32px;
            line-height: 36px;
        }
    }

    .ColoredText {
        color: ${({theme}) => theme?.light?.primary};
    }
`;
